export const CURRENCIES = [
  { code: 'MAD', symbol: 'DH',  label: 'Dirham marocain (MAD)', position: 'after'  },
  { code: 'EUR', symbol: '€',   label: 'Euro (EUR)',             position: 'before' },
  { code: 'USD', symbol: '$',   label: 'Dollar américain (USD)', position: 'before' },
];

export const formatPrice = (price, currency = 'MAD') => {
  const cur = CURRENCIES.find(c => c.code === currency) || CURRENCIES[0];
  const amount = parseFloat(price).toFixed(2);
  return cur.position === 'before' ? `${cur.symbol}${amount}` : `${amount} ${cur.symbol}`;
};
